import css from 'styled-jsx/css';
import { colors, screen, fonts } from 'components/styles/variables';
import { makeStyles } from '@mui/styles';
import { theme } from 'components/Shared/ThemeProviderWrapper';
import hoverIcon from 'public/static/images/srp/srp-tile-hover-icon.svg';
import restingIcon from 'public/static/images/srp/srp-tile-resting-icon.svg';

export const useStyles = makeStyles({
  dialog: {
    height: 'auto',
    width: '456px',
    padding: '26px 16px 38px 16px',
    borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '100%',
      borderRadius: '0px',
    },
  },
  imageContainer: {
    height: '100%',
    width: '100%',
    minWidth: '284px',
    borderRadius: '8px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    marginBottom: '8px',
    position: 'relative',
    overflow: 'hidden',
    perspective: '1px',
    backgroundColor: `${colors.G2}`,
    [`@media (min-width: ${screen.smMin})`]: {
      width: '284px',
      height: '168px',
      paddingBottom: 'unset',
      margin: '16px 0 16px 16px',
    },
    '& span': {
      display: 'block !important',
    },
  },
});

const styles = css`
  .monthly-payment-container {
    position: absolute;
  }

  @media (max-width: ${screen.smMin}) {
    .monthly-payment-container {
      right: 16px;
      bottom: 92px;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .monthly-payment-container {
      right: 24px;
      top: 56px;
    }
  }

  .details {
    text-decoration: none;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    .details {
      display: flex;
      flex-grow: 1;
      position: relative;
      padding: unset;
      border-radius: 16px;
      border: 1px ${colors.G2} solid;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
    }
  }
  .card-wrapper {
    display: flex;
    width: 100%;
  }
  .search-result {
    display: flex;
    background-color: ${colors.WHITE};
    flex-direction: column;
    padding: 16px;
    color: ${colors.BLACK};
    flex-grow: 1;
    position: relative;
    font-family: ${fonts.default};
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    text-decoration: none;
  }
  .tile-icon {
    display: flex;
    order: 1;
    position: relative;
    left: -10px;
    top: 80px;
    background-image: url(${restingIcon});
    height: 33px;
    width: 16px;
    cursor: pointer;
  }
  .tile-icon:hover {
    background-image: url(${hoverIcon});
  }

  @media (hover: hover) and (pointer: fine) {
    .search-result:hover {
      box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .search-result {
      height: 200px;
      flex-direction: row;
      padding: unset;
      border-radius: 16px;
      max-width: 1038px;
    }
  }

  .contact-cta-container {
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
  }

  @media (min-width: ${screen.smMin}) {
    .contact-cta-container {
      bottom: 23px;
      right: 24px;
    }
  }

  .vehicle-details {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  @media (min-width: ${screen.smMin}) {
    .vehicle-details {
      margin-top: 24px;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  @media (min-width: ${screen.smMin}) {
    .left {
      padding-left: 24px;
      width: 100%;
    }
  }

  @media (min-width: 950px) {
    .left {
      flex-basis: 40%;
    }
  }

  @media (min-width: 1200px) and (max-width: 1320px) {
    .left {
      flex-basis: 80%;
    }
  }

  .year-make-model {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.2px;
    padding-bottom: 6px;

    // allows ellipsis overflow on second line. see: https://stackoverflow.com/questions/5269713/css-ellipsis-on-second-line
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 55px;
    padding-bottom: 3px;
  }

  .miles-location {
    display: flex;
    flex-direction: row;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
  }

  @media (min-width: ${screen.smMin}) {
    .miles-location {
      flex-direction: column;
    }

    .year-make-model {
      font-size: 20px;
    }
  }

  @media (max-width: ${screen.smMin}) {
    .year-make-model {
      padding-bottom: 3px;
    }

    .miles-location {
      flex-direction: column;
      gap: 1px;
    }
  }

  .dealer-location {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .dealer-location {
      display: flex;
      position: absolute;
      bottom: 24px;
    }

    .location {
      padding-top: 5px;
    }
  }

  .dealer-name {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.2px;
    padding-left: 8px;
  }

  .time-on-market-container-mobile {
    display: flex;
    padding-top: 18px;
    padding-bottom: 7px;
  }

  @media (min-width: ${screen.smMin}) {
    .time-on-market-container-mobile {
      display: none;
    }
  }

  .buyer-intelligence {
    display: none;
  }

  @media (min-width: 950px) {
    .buyer-intelligence {
      display: flex;
      flex-direction: column;
      padding-left: 24px;
      flex-basis: 40%;
    }
  }

  @media (min-width: 1200px) and (max-width: 1320px) {
    .buyer-intelligence {
      display: none;
    }
  }

  .price-comparison-container,
  .price-change-container,
  .time-on-market-container,
  .no-data-container {
    display: flex;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.2px;
  }

  .price-change,
  .time-on-market {
    font-weight: 600;
    padding: 0 3px 0 8px;
  }

  .large-price-difference {
    line-height: 20px;
  }

  .price-comparison {
    font-weight: 600;
  }

  .no-data,
  .price-comparison-text {
    padding-left: 8px;
  }

  .positive {
    color: ${colors.ALG1};
  }

  .negative {
    color: ${colors.ALR1};
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-basis: 20%;
  }

  @media (min-width: ${screen.smMin}) {
    .right {
      margin-right: 24px;
      min-width: 121px;
    }
  }

  .badge-container-mobile {
    display: flex;
    position: absolute;
    bottom: 12px;
    left: 12px;
  }

  @media (min-width: ${screen.smMin}) {
    .badge-container-mobile {
      display: none;
    }
  }

  .badge-container {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .badge-container {
      display: flex;
      justify-content: right;
      margin-top: 12px;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .monthly-payment {
      line-height: 24px;
    }
  }

  .image-container {
    border-radius: 8px;
  }
`;
export default styles;
